import { Component } from '@angular/core';

import { TwistLogoComponent } from '@twist/ui/components';

@Component({
  standalone: true,
  imports: [TwistLogoComponent],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent {}
